import { render, staticRenderFns } from "./Cate.vue?vue&type=template&id=ce2d9372&scoped=true"
import script from "./Cate.vue?vue&type=script&lang=js"
export * from "./Cate.vue?vue&type=script&lang=js"
import style0 from "./Cate.vue?vue&type=style&index=0&id=ce2d9372&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce2d9372",
  null
  
)

export default component.exports